module.exports = __webpack_public_path__ + "images/d5efb34d5ac4730f12d37e33b9a005a1-GarageDoorCard_Image.svg";